import styled, { css } from "styled-components";

export const RelativeContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const BottomButtonContainer = styled.div<{ $isSticky?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 92rem;

  background-color: #ffffff;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-16, 1.6rem);
  border-top: 0.1rem solid #e5e7eb;
  z-index: 30;

  ${({ $isSticky }) =>
    $isSticky &&
    css`
      position: sticky;
      margin-left: -1.5%;
      min-width: 128rem;
      width: calc(100% + 2.2%);
    `}
`;

export const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
`;
